import React from 'react'

const CloseFill = props => (
  <svg
    viewBox='0 0 12 12'
    width={props.width || '12px'}
    height={props.height || '12px'}
  >
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g
        transform='translate(-1.000000, -1.000000)'
        fill={props.color || '#000'}
        fillRule='nonzero'
      >
        <path d='M8.41,7 L12.71,2.71 C13.1021222,2.31787783 13.1021222,1.68212217 12.71,1.29 C12.3178778,0.897877828 11.6821222,0.897877828 11.29,1.29 L7,5.59 L2.71,1.29 C2.31787783,0.897877838 1.68212218,0.897877842 1.29000001,1.29000001 C0.897877842,1.68212218 0.897877838,2.31787783 1.29,2.71 L5.59,7 L1.29,11.29 C1.10068735,11.4777666 0.994201676,11.7333625 0.994201676,12 C0.994201676,12.2666375 1.10068735,12.5222334 1.29,12.71 C1.4777666,12.8993127 1.73336246,13.0057983 2,13.0057983 C2.26663754,13.0057983 2.5222334,12.8993127 2.71,12.71 L7,8.41 L11.29,12.71 C11.4777666,12.8993127 11.7333625,13.0057983 12,13.0057983 C12.2666375,13.0057983 12.5222334,12.8993127 12.71,12.71 C12.8993127,12.5222334 13.0057983,12.2666375 13.0057983,12 C13.0057983,11.7333625 12.8993127,11.4777666 12.71,11.29 L8.41,7 Z' />
      </g>
    </g>
  </svg>
)

export default CloseFill
